import { OPEN_MODAL, CLOSE_MODAL, RESET_MODAL, SET_MODAL_READY } from 'reducers/actions-types';


let oldPath;

export default function modalReducer(state = {
    content: false,
    layout: null,
    meta: null,
    href: null,
    mustRefreshOnClose: false,
    isAsyc: false,
    isReady: false,
    isVisible: false,
    isPendingRemove: false,
}, { type, content, layout, href, isReady, meta, isAsync, mustRefreshOnClose }) {
    switch (type) {
        case OPEN_MODAL:
            if (href) {
                oldPath = window.location.pathname;
                history.pushState(null, '', href);
            }

            return Object.assign({}, state, {
                content,
                layout,
                href,
                meta,
                isPendingRemove: false,
                mustRefreshOnClose,
                isReady: !isAsync,
                isVisible: true,
            });
        case CLOSE_MODAL:
            return Object.assign({}, state, { isPendingRemove: true });
        case SET_MODAL_READY:
            return Object.assign({}, state, { isReady });
        case RESET_MODAL:
            if (state.href && window.location.pathname !== oldPath) {
                history.replaceState(null, '', oldPath);
            }

            return Object.assign({}, state, {
                content: null,
                layout: null,
                meta: null,
                href: null,
                isVisible: false,
                isReady: false,
                isAsyc: false,
                isPendingRemove: false,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/modal/index.js